<template>
  <!-- 首页 -->
	<div id="home" class="home">
    <Header></Header>
    <Navigate></Navigate>
    <div class="home_contentA">
      <!-- PC端轮播 -->
      <el-carousel height="541px" :interval="4000" class="webSwiper">
        <el-carousel-item v-for="(item,index) in lunbo" :key="index">
          <a>
            <img :src="item.TitlePhoto" />
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="home_contentAB">
      <div class="home_contentA_right">
        <!-- 焦点 -->
        <div class="home_contentA_right_top">
          <div class="home_contentA_right_title">
            <div class="dynamic"></div>
            <div class="swiper_more">
              <span @click="toMenu('/Focus/Foucslist')">MORE</span>
              <i class="iconfont icon-youjiantou"></i>
            </div>
          </div> 
          <el-carousel height="130px" :interval="3500" class="webSwiper swiper-container" direction="vertical">
            <el-carousel-item v-for="(item,index) in newDong" :key="index">
              <router-link :to="{name:'Foucsdetail',query:{id:item.ContentID}}">
                <p v-html="item.Title"></p>
                <p>{{item.Abstruct}}</p>
              </router-link>
              
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="home_contentA_right_bottom">
          <div class="flRseniority_just">
            <span>专题活动</span>
            <span @click="toMenu('/Themactive/NonMember')">MORE <i class="iconfont icon-youjiantou"></i></span>
          </div>
          <ul>
            <li v-for="(item,index) in article" :key="index" v-if="index < 3" @mouseenter="onMouseOverA(index)">
              <i class="rig_bto_icon">{{index+1}}</i>
              <span><router-link :to="{name:'NonMemberdetail',query:{id:item.ContentID}}" v-html="item.Title"></router-link></span>
              <span>{{item.AddDate}}</span><br>
              <div v-if="index == articleShow">{{item.Abstruct}}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="home_contentB">
      <div class="flRseniority_just">
        <span>特别推荐</span>
        <!-- <span @click="toMenu('/Appcounter')">MORE <i class="iconfont icon-youjiantou"></i></span> -->
      </div>
      <ul>
        <li v-for="(item,index) in yydcList" :key="index" @click="tomenuLinkurl(item.Linkurl,item)">
          <img :src="item.TitlePhoto" alt="">
        </li>
      </ul>
    </div>

    <div class="home_contentG">
      <div class="flRseniority_just">
        <span>协会动态</span>
        <span @click="toMenu('/Assocdynamic/NewsCenter')">MORE <i class="iconfont icon-youjiantou"></i></span>
      </div>
      <ul class="home_contentC_left_just_ul">
        <li v-for="(item,index) in thrsearch" :key="index">
          <div class="periodiCon_cluster_Cont_img">
            <img :src="item.TitlePhoto" alt="" v-if="item.TitlePhoto != LmurL">
				    <img src="../../../static/banImage/defaultpic.png" alt="" v-if="item.TitlePhoto == LmurL">
          </div>
          <div class="periodiCon_cluster_Cont_right">
            <p><router-link :to="{name:'NewsCenterdetail',query:{
              id:item.ContentID
            }}" v-html="item.Title"></router-link></p>
            <p class="periodiCon_cluster_Cont_right_p2" v-html="item.Abstruct"></p>
            <p>
              <span>{{item.AddDate}}</span>
            </p>
          </div>
        </li>
        <div style="clear:both;"></div>
      </ul>
    </div>

    <div class="home_contentD">
      <div class="home_contentC_left_just">
        <div class="flRseniority_just">
          <span>协会领导</span>
          <span @click="toMenu('/Assocwindow/ContactInfo')">MORE <i class="iconfont icon-youjiantou"></i></span>
        </div>
      </div>
      <div class="swiper-container" id="swiper-container">
        <div class="swiper-wrapper" id="swiper-wrapper">
          <div class="swiper-slide" id="swiper-slide" v-for="(item,index) in swiper" :key="index" ref="swiperBS" >
            <img :src="item.TitlePhoto" alt="">
            <p v-html="item.Title"></p>
            <router-link :to="{name:'ContactInfodetail',query:{id:item.ContentID}}"></router-link>
            <div class="swiper_slide_cover">
              {{item.Abstruct}}
            </div>
          </div>
        </div>
        <div class="swiper-button-next">
          <i class="iconfont icon-arrow-right"></i>
        </div>
        <div class="swiper-button-prev">
          <i class="iconfont icon-zuojiantou"></i>
        </div>
      </div>
    </div>

    <div class="home_contentC">
      <div class="home_contentC_left">
        <div class="home_contentC_left_just">
          <div class="flRseniority_just">
            <span>通知公告</span>
            <span @click="toMenu('/Notifiannou/Notifiannoulist')">MORE <i class="iconfont icon-youjiantou"></i></span>
          </div>
          <ul>
            <div class="home_contentC_left_just_zsfb" v-for="(itemC,indexB) in partlearn"  v-if="indexB < 1">
              <router-link :to="{name:'Notifiannoudetail',query:{id:itemC.ContentID}}">
                <div class="home_contentC_left_just_zsfb_img">
                  <img :src="itemC.TitlePhoto" alt="">
                </div>
                <p class="home_contentC_left_just_zsfb_tit" v-html="itemC.Title"></p>
              </router-link>
            </div>
            <li v-for="(item,index) in partlearn" :key="index" @mouseenter="onMouseOverB(index)">
              <i class="rig_bto_icon">{{index+1}}</i>
              <span><router-link :to="{name:'Notifiannoudetail',query:{id:item.ContentID}}" v-html="item.Title"></router-link></span>
              <span>{{item.AddDate}}</span><br>
              <div v-if="index == partlearnShow">{{item.Abstruct}}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="home_contentC_right">
        <div class="home_contentC_right_just">
          <div class="flRseniority_just">
            <span>文化讲堂</span>
            <li>
              <div class="home_contentC_right_just_type" :class="{just:just===0}" @mouseenter="just=0">文化讲堂</div>
              <div class="home_contentC_right_just_type" :class="{just:just===1}" @mouseenter="just=1">情况交流</div>
              <span @click="toMenu('/Associvoice/Culturelec')">MORE <i class="iconfont icon-youjiantou"></i></span>
            </li>
          </div>
        </div>
        <ul v-show="just===0">
          <li v-for="(item,index) in CulturHall" :key="index"  @mouseenter="onMouseOverC(index)">
            <i class="rig_bto_icon">{{index+1}}</i>
            <span><router-link :to="{name:'Culturelecdetail',query:{id:item.ContentID}}" v-html="item.Title"></router-link></span>
            <span>{{item.AddDate}}</span><br>
            <div v-if="index == academicShow">{{item.Abstruct}}</div>
          </li>
        </ul>
        <ul v-show="just===1" id="academicB">
          <li v-for="(item,index) in IsCommuni" :key="index">
            <i class="rig_bto_icon">{{index+1}}</i>
            <span><router-link :to="{name:'Iscommunidetail',query:{id:item.ContentID}}" v-html="item.Title"></router-link></span>
            <span>{{item.AddDate}}</span><br>
          </li>
        </ul>
      </div>
    </div>

    <div class="home_contentAC">
      <div class="home_contentA_right">
        <div class="home_contentA_right_top">
          <div class="flRseniority_just">
            <span>会员活动</span>
            <span @click="toMenu('/Memactive/Memactivelist')">MORE <i class="iconfont icon-youjiantou"></i></span>
          </div>
          <el-carousel height="190px" :interval="2500" class="webSwiper swiper-container" direction="vertical">
            <el-carousel-item v-for="(item,index) in newDongD" :key="index">
              <router-link :to="{name:'Memactivedetail',query:{id:item.ContentID}}">
                <div class="home_contentC_left_just_zsfb">
                  <div class="home_contentC_left_just_zsfb_img">
                    <img :src="item.TitlePhoto" alt="">
                  </div>
                  <p class="home_contentC_left_just_zsfb_tit" v-html="item.Title"></p>
                </div>
              </router-link>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="home_contentA_right_bottom">
          <div class="flRseniority_just">
            <span>协会之声</span>
            <!-- <span @click="toMenu('/PartLearn/NewsCenter')">MORE <i class="iconfont icon-youjiantou"></i></span> -->
          </div>
          <ul>
            <div class="home_contentC_left_just_zsfb">
              <ul>
                <li>
                  <img src="../../../static/banImage/tushu1.jpg" alt="">
                </li>
                <li>
                  <img src="../../../static/banImage/tushu2.jpg" alt="">
                </li>
                <li>
                  <img src="../../../static/banImage/tushu3.jpg" alt="">
                </li>
              </ul>
            </div>
          </ul>
        </div>
      </div>
    </div>

    <div class="home_contentF">
      <div class="home_contentC_left_just">
        <div class="flRseniority_just">
          <span>相关链接</span>
          <span @click="toMenu('/CooperaBase')">MORE <i class="iconfont icon-youjiantou"></i></span>
        </div>
      </div>
      <div class="home_contentF_bto">
        <ul>
          <li v-for="(item,index) in linkUrl" :key="index" @click="tolinkurk(item.SiteUrl)">
            <img :src="item.LogoUrl" alt="">
          </li>
        </ul>
      </div>
    </div>
    <Foot></Foot>
	</div>
</template>

<script>
import router from '@/router/index'
// import Swiper from 'swiper';
import Header from '@/components/public/heade/index'
import Navigate from '@/components/public/navigation/index'
import Foot from '@/components/public/foot/index'
import axios from 'axios'
export default {
	name:'home',
	data(){
		return{
      LmurL:'https://uniappfile.boyuancb.com',
      just:0,
      articleShow:false,
      partlearnShow:false,
      academicShow:false,
      lunbo:[
        {
          TitlePhoto:'../../../static/banImage/banner.png'
        },
        {
          TitlePhoto:'../../../static/banImage/banner.png'
        },
        {
          TitlePhoto:'../../../static/banImage/banner.png'
        }
        // {
        //   img:'../../../static/banner01.jpg',
        //   title:'地方医师协会秘书长、二级机构总干事联席会议在京召开'
        // },
        // {
        //   img:'../../../static/banner02.jpg',
        //   title:'地方医师协会秘书长、二级机构总干事联席会议在京召开'
        // },
        // {
        //   img:'../../../static/banner03.jpg',
        //   title:'地方医师协会秘书长、二级机构总干事联席会议在京召开'
        // }
      ],
      article:[
        {
          id:'1',
          title:'-地方医师协会秘书长、二级机构总干事联席会议在京召开',
          date:'2019-10-12',
          para:'2018年4月6日，全公益-地方医师协会秘书长、二级机构总干事联席会议在京召开正式启动。项目采用线上线下相结合'
        },
        {
          id:'2',
          title:'-地方医师协会秘书长、二级机构总干事联席会议在京召开',
          date:'2019-10-12',
          para:'2018年4月6日，全公益-地方医师协会秘书长、二级机构总干事联席会议在京召开正式启动。项目采用线上线下相结合'
        },
        {
          id:'3',
          title:'-全科医师心血管疾病防治能力提升项目',
          date:'2019-10-12',
          para:'2018年4月6日，全公益-地方医师协会秘书长、二级机构总干事联席会议在京召开正式启动。项目采用线上线下相结合'
        },
        {
          id:'4',
          title:'-2019中国医师协会呼吸医师年会在福州盛大开幕',
          date:'2019-10-12',
          para:'2018年4月6日，全公益-地方医师协会秘书长、二级机构总干事联席会议在京召开正式启动。项目采用线上线下相结合'
        },
        {
          id:'5',
          title:'-2019中国医师协会呼吸医师年会在福州盛大开幕',
          date:'2019-10-12',
          para:'2018年4月6日，全公益-地方医师协会秘书长、二级机构总干事联席会议在京召开正式启动。项目采用线上线下相结合'
        }
      ],
      newDong:[],

      // 会员活动
      newDongD:[
        {
          TitlePhoto:'',
          Title:'公示：中国新闻文化促进会社会团体法人登记证书副本'
        },
        {
          TitlePhoto:'',
          Title:'公示：中国新闻文化促进会社会团体法人登记证书副本'
        },
        {
          TitlePhoto:'',
          Title:'公示：中国新闻文化促进会社会团体法人登记证书副本'
        }
      ],

      // 党建学习
      partlearn:[
        {
          Abstruct: "", //简介
          AddDate: "", //添加时间（通过编辑数据库改为出版时间）
          Author: "", //作者（手动填写）
          ChannelID:1, //栏目ID
          Content: "", //全文（是富文本）
          ContentID:1, //文章ID
          EditAuthor:1, //最后编辑用户ID
          EditDate: "",//最后编辑时间
          FJName: "", //附件文件名
          FJPath: "",//附件地址（加前缀‘http://shfzyjzx.boyuancb.com/Admin’）
          HitCount: 1,//点击次数
          InAuthor: 1, //添加人ID
          InAuthorName: "",//添加人姓名（不可自定义）
          IsBold: 1,//标题字体是否加粗
          IsHot: 1, //是否热点（手动勾选）
          IsItalic: 1,//标题字体是否斜体
          JournalID:1, //期刊ID（固定死的）
          Linkurl: "", //外链地址（此处会存带http://的完整url）
          SortID: 1, //排序值（数字小的在前）
          Source: "",//来源（出版社写在这个字段）
          Tags: "",//关键字
          Title: "",//标题
          TitleColor: "",//标题字体颜色
          TitlePhoto: "",//标题图片（加前缀‘http://shfzyjzx.boyuancb.com/Admin’）
        }
      ],
      academicB:[],
      swiper:[],
      // 三农研究
      thrsearch:[],
      yydcList:[],
      TitlePhoto:'',
      // Culture lecture hall
      CulturHall:'',
      // Is communication
      IsCommuni:'',
      linkUrl:[
        
      ],
		}
  },
  methods:{
    toMenu(url){
      this.$router.push({
        path:url
      })
    },
    onMouseOverA(index){
      this.articleShow = index
    },
    onMouseOutA(index){
      this.articleShow = index
    },
    onMouseOverB(index){
      this.partlearnShow = index
    },
    onMouseOutB(index){
      this.partlearnShow = index
    },
    onMouseOverC(index){
      this.academicShow = index
    },
    onMouseOutC(index){
      this.academicShow = index
    },

    // 轮播
    getlunbo(){
      // var params = new URLSearchParams();
      // params.append('ChannelID', 2613);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      // params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）
      // params.append('CurrentPage', 1);//当前页数
      // params.append('PageSize', 8);//页容量
      // axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
      //   this.lunbo = res.data._itemList
      //   this.lunbo.forEach((e) => {
      //     e.TitlePhoto = this.LmurL + e.TitlePhoto
      //   })
      //   // this.partlearn = res.data._itemList //_itemList是上面那个结构体
      //   // this.partlearn.forEach((item) => {
      //   //   item.AddDate = item.AddDate.substr(0,10)
      //   // })
      // })
    },

    // 通知公告
    getData(){
      var params = new URLSearchParams();
      params.append('ChannelID', 2858);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）
      params.append('CurrentPage', 1);//当前页数
      params.append('PageSize', 4);//页容量
      axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
        this.partlearn = res.data._itemList //_itemList是上面那个结构体
        this.partlearn.forEach((item) => {
          item.AddDate = item.AddDate.substr(0,10)
          item.TitlePhoto = this.LmurL + item.TitlePhoto
        })
      })
    },
    // 特别推荐
    getDataA(){
      var params = new URLSearchParams();
      params.append('ChannelID', 2828);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）
      params.append('CurrentPage', 1);//当前页数
      params.append('PageSize', 8);//页容量
      axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
        this.yydcList = res.data._itemList //_itemList是上面那个结构体
        this.yydcList.forEach((item) => {
          item.AddDate = item.AddDate.substr(0,10)
          item.TitlePhoto = item.TitlePhoto
        })
      })
    },
    tomenuLinkurl(url,item){
      if(url){
        window.open(url)
      } else {
        this.$router.push({
          path:'/Specialdetail',
          query:{
            id:item.ContentID
          }
        })
      }
    },
    // 专题活动
    getDataB(){
      var params = new URLSearchParams();
      params.append('ChannelID', 2838);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）
      params.append('CurrentPage', 1);//当前页数
      params.append('PageSize', 8);//页容量
      axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
        this.article = res.data._itemList //_itemList是上面那个结构体
        this.article.forEach((item) => {
          item.AddDate = item.AddDate.substr(0,10)
        })
      })
    },
    getDataR(){
			var params = new URLSearchParams();
			params.append('ChannelID', 2854);
			params.append('JournalID', 202007100001);
      params.append('CurrentPage', 1);
      params.append('PageSize', 3);
			axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
        this.newDong = res.data._itemList //_itemList是上面那个结构体
        this.initSwiper();
        this.newDong.forEach((item) => {
          item.AddDate = item.AddDate.substr(0,10)
          item.TitlePhoto = this.LmurL + item.TitlePhoto
        })
      })
    },
    // 协会领导
    getDataC(){
      var params = new URLSearchParams();
      params.append('ChannelID', 2833);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）IncludeChildChannel
      params.append('IncludeChildChannel', true); //期刊ID（固定死就是这个）
      params.append('CurrentPage', 1);//当前页数
      params.append('PageSize', 50);//页容量
      axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
        this.swiper = res.data._itemList //_itemList是上面那个结构体
        this.swiper.forEach((item) => {
          item.AddDate = item.AddDate.substr(0,10)
          item.TitlePhoto = this.LmurL + item.TitlePhoto
        })
      })
    },
    // 文化讲堂
    getDataD(){
      var params = new URLSearchParams();
      params.append('ChannelID', 2852);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）
      params.append('CurrentPage', 1);//当前页数
      params.append('PageSize', 8);//页容量
      axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
        this.CulturHall = res.data._itemList //_itemList是上面那个结构体
        this.CulturHall.forEach((item) => {
          item.AddDate = item.AddDate.substr(0,10)
        })
      })
    },
    // 情况交流
    getDataE(){
      var params = new URLSearchParams();
      params.append('ChannelID', 2853);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）
      params.append('CurrentPage', 1);//当前页数
      params.append('PageSize', 1000000);//页容量
      axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
        this.IsCommuni = res.data._itemList //_itemList是上面那个结构体
        this.IsCommuni.forEach((item) => {
          item.AddDate = item.AddDate.substr(0,10)
          item.TitlePhoto = this.LmurL + item.TitlePhoto
          this.IsCommuni = this.IsCommuni.sort(this.compare("Linkurl"));
        })
      })
    },
    // 文章
    getDataF(){
      var params = new URLSearchParams();
      params.append('ChannelID', 2433);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）
      params.append('CurrentPage', 1);//当前页数
      params.append('PageSize', 100000);//页容量
      axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
        this.academicB = res.data._itemList //_itemList是上面那个结构体
        this.academicB.forEach((item) => {
          item.EditDate = item.EditDate.substr(0,10)
          item.TitlePhoto = this.LmurL + item.TitlePhoto
          this.academicB = this.academicB.sort(this.compare("Linkurl"));
        })
      })
    },
    // 协会动态
    getDataDD(){
      var params = new URLSearchParams();
      params.append('ChannelID', 2837);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）
      params.append('CurrentPage', 1);//当前页数
      params.append('PageSize', 4);//页容量
      axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
        this.thrsearch = res.data._itemList //_itemList是上面那个结构体
        this.thrsearch.forEach((item) => {
          item.EditDate = item.EditDate.substr(0,10)
          item.TitlePhoto = this.LmurL + item.TitlePhoto
          item.AddDate = item.AddDate.substr(0,10)
        })
      })
    },
    // 会员活动
    getHyacti(){
      var params = new URLSearchParams();
      params.append('ChannelID', 2855);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）
      params.append('CurrentPage', 1);//当前页数
      params.append('PageSize', 4);//页容量
      axios.post('/SiteContentAPI/GetPageList',params).then((res) => {
        this.newDongD = res.data._itemList //_itemList是上面那个结构体
        this.newDongD.forEach((item) => {
          item.EditDate = item.EditDate.substr(0,10)
          item.TitlePhoto = this.LmurL + item.TitlePhoto
          item.AddDate = item.AddDate.substr(0,10)
        })
      })
    },
    // 相关链接
    getLinkurl(){
      var params = new URLSearchParams();
      params.append('ChannelID', 2859);  //栏目ID（2409是党建学习，2413是学者成果的著作）
      params.append('JournalID', 202007100001); //期刊ID（固定死就是这个）
      axios.post('/FriendlyLinkWebAPI/GetList',params).then((res) => {
        this.linkUrl = res.data.data //_itemList是上面那个结构体
        this.linkUrl.forEach((item) => {
          item.LogoUrl = this.LmurL + item.LogoUrl
        })
      })
    },
    // 相关链接跳转
    tolinkurk(url){
      window.open(url)
    },
    initSwiper(){
      this.$nextTick(function() {
        var swiper = new Swiper('#swiperB', {
          direction: 'vertical',
          loop:true,
          slidesPerView: 1,
          paginationClickable: true,
          spaceBetween: 30,
          centeredSlides: true,
          autoplay: 2500,
          autoplayDisableOnInteraction: false
        });
      })
    },
    compare(attr) {
      return function(a,b){
        var val1 = a[attr];
        var val2 = b[attr];
        return val1 - val2;
      }
    },
  },
  components:{
    Header,
    Navigate,
    Foot
  },
  created(){
    this.getData();
    this.getDataA();
    this.getDataB();
    this.getDataC();
    this.getDataD();
    this.getDataE();
    this.getDataF();
    this.getDataR();
    this.getDataDD();

    this.getlunbo();
    // 会员活动
    this.getHyacti();
    // 相关链接
    this.getLinkurl();
  },
  updated(){
    // console.log(document.getElementById('swiper-slide').offsetLeft)
    this.initSwiper();
    var swiper = new Swiper('#sipwewesss', {
      loop:true,
      autoplay: 2500,
      autoplayDisableOnInteraction: false,
      pagination: '.swiper-pagination',
      direction: 'vertical',
      paginationClickable: true,
      spaceBetween: 30,
    })

    var swiper = new Swiper('#swiper-container', {
      pagination: '.swiper-pagination',
      paginationClickable: '.swiper-pagination',
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      spaceBetween: 30,


      // pagination: '.swiper-pagination',
      // paginationClickable: true,
      // slidesPerView: 6,
      // pagination: '.swiper-pagination',
      // paginationClickable: '.swiper-pagination',
      // nextButton: '.swiper-button-next',
      // prevButton: '.swiper-button-prev',
      // spaceBetween: 30,
    });
    var swiper = new Swiper('#swiperA', {
      pagination: '.swiper-pagination',
      slidesPerView: 5,
      paginationClickable: true,
      spaceBetween: 30,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
    });
  },
  mounted() {
    // console.log(document.getElementById('swiper-slide'))
    // console.log(document.getElementById('swiper-wrapper').offsetLeft)
    // if(document.getElementById('swiper-wrapper').offsetLeft == 0){
    //   $('.swiper-button-prev').css('display','none')
    // }
  },
}
</script>

<style lang="less" scoped>
	#home{
		width:100%;
		height:auto;
    .home_contentA{
      width: 100%;
      height: 541px;
      position: relative;
      top: -5px;
      img {
        width: 100%;
        height: 100%;
      }
      /deep/.el-carousel--horizontal{
        width: 100%;
        height: 100%;
        position: absolute;
        .el-carousel__container{
          width: 100%;
          height: 100%;
        }
      }
      /deep/.el-carousel--horizontal img {
        width: 100%;
        height: 100%;
      }
      background-size: cover;
    }
    .home_contentAB{
      width: 1200px;
      height: 200px;
      margin: 0 auto;
      margin-top: 41px;
      .home_contentA_right{
        width: 100%;
        height: 200px;
        .home_contentA_right_top{
          width: 580px;
          height: 200px;
          background: #F8F8F8;
          float: left;
          .home_contentA_right_title{
            width:100%;
            height:33px;
            position: relative;
            .dynamic{
              width: 96px;
              height: 33px;
              background:url('../../../static/banImage/标签.png')no-repeat;
              background-size:cover;
              padding-left: 8px;
              line-height: 24px;
              font-size: 14px;
              color:#fff;
            }
            .swiper_more{
              float: right;
              position: relative;
              top: -26px;
              span{
                color: #C01B22;
                font-size:16px;
                cursor: pointer;
              }
              i{
                color: #C01B22;
                font-size: 20px;
                font-weight: bold;
                position: relative;
                top: 2px;
              }
            }
            .swiper-pagination{
              width: 91px!important;
              height:20px!important;
              position: absolute;
              top: 4px;
              left: 71%;
              /deep/.swiper-pagination-bullet{
                width: 20px!important;
                height: 20px!important;
                border:1px solid #C01B22;
                border-radius: 0;
                margin-right: 6px;
                background: transparent;
              }
              /deep/.swiper-pagination-bullet-active{
                background:#C01B22!important;
              }
            }
          }
          /deep/.swiper-container{
            top: 25px;
            left: 36px;
          }
          /deep/.el-carousel__container{
            position: relative;
            top: 3px;
          }
          /deep/.el-carousel__indicators{
            display: none;
          }
          /deep/.el-carousel__item{
            width: 100%!important;
            height: 100%!important;
            p:nth-child(1){
              width: 94%;
              color: #C01B22;
              font-size: 20px;
              margin: 0 auto;
              // text-indent: 2em;
              font-weight: bold;
              margin-top: 8px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              cursor:pointer;
            }
            p:nth-child(2){
              width: 94%;
              color: #151515;
              font-size: 14px;
              // text-indent: 2em;
              margin: 0 auto;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              margin-top: 3px;
              cursor:pointer;
            }
          }
        }
        .home_contentA_right_bottom{
          width: 580px;
          height: 192px;
          float: right;
          .flRseniority_just{
            width: 580px;
            height: 32px;
            span:nth-child(1){
              float: left;
              width: 88px;
              height: 32px;
              color: #333;
              font-size: 20px;
              text-align: center;
              line-height: 22px;
              font-family: 'SourceHanSansSC-Regular';
              border-bottom:2px solid #C01B22;
              cursor: pointer;
            }
            span:nth-child(2){
              float: right;
              width: 488px;
              height: 32px;
              color:#C01B22;
              line-height: 33px;
              font-size: 16px;
              text-align: right;
              border-bottom: 2px solid #EEEEEE;
              cursor: pointer;
              i{
                color: #C01B22;
                font-size: 20px;
                font-weight: bold;
                position: relative;
                top: 2px;
              }
            }
          }
          ul{
            width: 100%;
            height: 100%;
            li{
              list-style: none;
              padding: 3px;
              margin-bottom:10px;
              position: relative;
              .rig_bto_icon{
                width: 20px;
                height: 20px;
                background: #C01B22;
                position: absolute;
                border-radius: 50%;
                float: left;
                display: inherit;
                text-align: center;
                line-height: 21px;
                color: #fff;
                font-style: normal;
              }
              span:nth-child(2){
                width: 79%;
                float: left;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
                box-orient: vertical;
                margin-left: 31px;
                a{
                  color: #151515;
                  font-size: 16px;
                }
              }
              span:nth-child(3){
                float: right;
                color: #151515;
                font-size: 14px;
              }
              div{
                width: 78%;
                text-align:justify;
                color: #151515;
                font-size: 14px;
                margin-top: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp:2;
                -webkit-box-orient: vertical;
                box-orient: vertical;
                // text-indent: 2em;
                margin-left: 30px;
              }
            }
            li:hover{
              div{color: #C01B22;}
              span:nth-child(2){a{color: #C01B22;}}
              span:nth-child(3){color: #C01B22;}
            }
          }
        }
      }
    }
    .home_contentB{
      width: 1200px;
      height: 155px;
      margin: 0 auto;
      margin-top: 41px;
      .flRseniority_just{
        width: 100%;
        height: 32px;
        span:nth-child(1){
          float: left;
          width: 88px;
          height: 32px;
          color: #333;
          font-size: 20px;
          text-align: center;
          line-height: 22px;
          font-family: 'SourceHanSansSC-Regular';
          border-bottom:2px solid #C01B22;
          cursor: pointer;
        }
        span:nth-child(2){
          float: right;
          width: 1108px;
          height: 32px;
          color:#C01B22;
          line-height: 33px;
          font-size: 16px;
          text-align: right;
          border-bottom: 2px solid #EEEEEE;
          cursor: pointer;
          i{
            color: #C01B22;
            font-size: 20px;
            font-weight: bold;
            position: relative;
            top: 2px;
          }
        }
      }
      ul{
        width: 100%;
        height: 100%;
        margin-top:15px;
        li{
          list-style: none;
          width: 380px;
          height: 105px;
          float: left;
          margin-left: 5px;
          margin-right: 8px;
          position: relative;
          cursor: pointer;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .home_contentC{
      width: 1200px;
      height:445px;
      margin: 0 auto;
      margin-top: 41px;
      .home_contentC_left{
        width: 580px;
        float: left;
        height: 414px;
        .flRseniority_just{
          width: 580px;
          height: 32px;
          span:nth-child(1){
            float: left;
            width: 88px;
            height: 32px;
            color: #333;
            font-size: 20px;
            text-align: center;
            line-height: 22px;
            font-family: 'SourceHanSansSC-Regular';
            border-bottom:2px solid #C01B22;
            cursor: pointer;
          }
          span:nth-child(2){
            float: right;
            width: 488px;
            height: 32px;
            color:#C01B22;
            line-height: 33px;
            font-size: 16px;
            text-align: right;
            border-bottom: 2px solid #EEEEEE;
            cursor: pointer;
            i{
              color: #C01B22;
              font-size: 20px;
              font-weight: bold;
              position: relative;
              top: 2px;
            }
          }
        }
        ul{
          width: 100%;
          height: 100%;
          margin-top: 5px;
          .home_contentC_left_just_zsfb{
            width: 580px;
            height: 173px;
            border: 1px solid #E6E6E6;
            margin-top: 11px;
            cursor: pointer;
            .home_contentC_left_just_zsfb_img{
              width: 212px;
              height: 145px;
              float: left;
              margin-top: 14px;
              margin-left: 18px;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .home_contentC_left_just_zsfb_tit{
              width: 52%;
              float: left;
              margin-left: 24px;
              margin-top: 78px;
              font-size: 16px;
              color: #151515;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              white-space:nowrap;
            }
          }
          li{
            list-style: none;
            padding: 3px;
            margin-bottom:6px;
            .rig_bto_icon{
              width: 20px;
              height: 20px;
              background: #D3D3D3;
              position: absolute;
              border-radius: 50%;
              float: left;
              display: inherit;
              text-align: center;
              line-height: 21px;
              color: #fff;
              font-style: normal;
            }
            span:nth-child(2){
              width: 79%;
              float: left;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              margin-left: 31px;
              a{
                color: #151515;
                font-size: 16px;
              }
            }
            span:nth-child(3){
              float: right;
              color: #151515;
              font-size: 14px;
            }
            div{
              width: 78%;
              text-align:justify;
              color: #151515;
              font-size: 14px;
              margin-top: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              // text-indent: 2em;
              margin-left: 30px;
            }
          }
          li:nth-child(2),li:nth-child(3),li:nth-child(4){
            .rig_bto_icon{
              background: #C01B22;
            }
          }
          li:nth-child(2){
            margin-top: 23px;
          }
          li:hover{
            div{color: #C01B22;}
            span:nth-child(2){a{color: #C01B22;}}
            span:nth-child(3){color: #C01B22;}
          }
        }
      }
      .home_contentC_right{
        width: 580px;
        float: right;
        height: 414px;
        .flRseniority_just{
          width: 580px;
          height: 32px;
          span:nth-child(1){
            float: left;
            width: 88px;
            height: 32px;
            color: #333;
            font-size: 20px;
            text-align: center;
            line-height: 22px;
            font-family: 'SourceHanSansSC-Regular';
            border-bottom:2px solid #C01B22;
            cursor: pointer;
          }
          li{
            list-style: none;
            float: right;
            width: 488px;
            height: 32px;
            color:#C01B22;
            line-height: 33px;
            font-size: 16px;
            text-align: right;
            border-bottom: 2px solid #EEEEEE;
            cursor: pointer;
            .just{
              background: #C01B22;
              color: #fff!important;
            }
            .home_contentC_right_just_type{
              float: left;
              width: 97px;
              height: 29px;
              color: #969696;
              font-size: 16px;
              line-height: 31px;
              text-align: center;
              margin-left: 15px;
            }
            i{
              color: #C01B22;
              font-size: 20px;
              font-weight: bold;
              position: relative;
              top: 2px;
            }
          }
        }
        ul{
          width: 100%;
          height: 100%;
          margin-top: 11px;
          li:nth-child(1),li:nth-child(2){
            margin-bottom: 13px;
          }
          li:hover{
            div{color: #C01B22;}
            span:nth-child(2){a{color: #C01B22;}}
            span:nth-child(3){color: #C01B22;}
          }
          li{
            list-style: none;
            padding: 3px;
            margin-bottom:6px;
            .rig_bto_icon{
              width: 20px;
              height: 20px;
              background: #D3D3D3;
              position: absolute;
              border-radius: 50%;
              float: left;
              display: inherit;
              text-align: center;
              line-height: 21px;
              color: #fff;
              font-style: normal;
            }
            span:nth-child(2){
              width: 79%;
              float: left;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              margin-left: 31px;
              a{
                color: #151515;
                font-size: 16px;
              }
            }
            span:nth-child(3){
              float: right;
              color: #151515;
              font-size: 14px;
            }
            div{
              width: 78%;
              text-align:justify;
              color: #151515;
              font-size: 14px;
              margin-top: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              // text-indent: 2em;
              margin-left: 30px;
            }
          }
          li:nth-child(1),li:nth-child(2),li:nth-child(3){
            .rig_bto_icon{
              background: #C01B22;
            }
          }
        }
      }
    }
    .home_contentAC{
      width: 1200px;
      height: 229px;
      margin: 0 auto;
      margin-top: 41px;
      .home_contentA_right{
        width: 100%;
        height: 222px;
        .home_contentA_right_top{
          width: 580px;
          height: 222px;
          float: left;
          .flRseniority_just{
            width: 580px;
            height: 32px;
            span:nth-child(1){
              float: left;
              width: 88px;
              height: 32px;
              color: #333;
              font-size: 20px;
              text-align: center;
              line-height: 22px;
              font-family: 'SourceHanSansSC-Regular';
              border-bottom:2px solid #C01B22;
              cursor: pointer;
            }
            span:nth-child(2){
              float: right;
              width: 488px;
              height: 32px;
              color:#C01B22;
              line-height: 33px;
              font-size: 16px;
              text-align: right;
              border-bottom: 2px solid #EEEEEE;
              cursor: pointer;
              i{
                color: #C01B22;
                font-size: 20px;
                font-weight: bold;
                position: relative;
                top: 2px;
              }
            }
          }
          .home_contentC_left_just_zsfb{
            width: 580px;
            height: 173px;
            border: 1px solid #E6E6E6;
            margin-top: 11px;
            .home_contentC_left_just_zsfb_img{
              width: 212px;
              height: 145px;
              float: left;
              margin-top: 14px;
              margin-left: 18px;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .home_contentC_left_just_zsfb_tit{
              width: 52%;
              float: left;
              margin-left: 24px;
              margin-top: 78px;
              font-size: 16px;
              color: #151515;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              white-space:nowrap;
            }
          }
          /deep/.el-carousel__container{
            position: relative;
            top: 3px;
          }
          /deep/.el-carousel__indicators{
            display: none;
          }
          /deep/.el-carousel__item{
            width: 100%!important;
            height: 100%!important;
          }
        }
        .home_contentA_right_bottom{
          width: 580px;
          height: 192px;
          float: right;
          .flRseniority_just{
            width: 580px;
            height: 32px;
            span:nth-child(1){
              float: left;
              width: 88px;
              height: 32px;
              color: #333;
              font-size: 20px;
              text-align: center;
              line-height: 22px;
              font-family: 'SourceHanSansSC-Regular';
              border-bottom:2px solid #C01B22;
              cursor: pointer;
            }
            span:nth-child(2){
              float: right;
              width: 488px;
              height: 32px;
              color:#C01B22;
              line-height: 33px;
              font-size: 16px;
              text-align: right;
              border-bottom: 2px solid #EEEEEE;
              cursor: pointer;
              i{
                color: #C01B22;
                font-size: 20px;
                font-weight: bold;
                position: relative;
                top: 2px;
              }
            }
          }
          .home_contentC_left_just_zsfb{
            width: 580px;
            height: 173px;
            border: 1px solid #E6E6E6;
            margin-top: 11px;
            ul{
              width: 100%;
              height: 100%;
              li{
                list-style: none;
                width: 120px;
                height: 150px;
                float: left;
                margin-top: 11px;
                margin-right: 68px;
                img{
                  width: 100%;
                  height: 100%;
                }
              }
              li:nth-child(1){
                margin-left: 33px;
              }
              li:nth-child(3){
                margin-right: 33px;
                border: 1px solid #efefef;
              }
            }
          }
          ul{
            width: 100%;
            height: 100%;
            li{
              list-style: none;
              padding: 3px;
              margin-bottom:10px;
              position: relative;
              .rig_bto_icon{
                width: 20px;
                height: 20px;
                background: #C01B22;
                position: absolute;
                border-radius: 50%;
                float: left;
                display: inherit;
                text-align: center;
                line-height: 21px;
                color: #fff;
                font-style: normal;
              }
              span:nth-child(2){
                width: 79%;
                float: left;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
                box-orient: vertical;
                margin-left: 31px;
                a{
                  color: #151515;
                  font-size: 16px;
                }
              }
              span:nth-child(3){
                float: right;
                color: #151515;
                font-size: 14px;
              }
              div{
                width: 78%;
                text-align:justify;
                color: #151515;
                font-size: 14px;
                margin-top: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                box-orient: vertical;
                // text-indent: 2em;
                margin-left: 30px;
              }
            }
          }
        }
      }
    }
    .home_contentD{
      width: 1200px;
      height: auto;
      margin: 0 auto;
      margin-top: 40px;
      .flRseniority_just{
        width: 100%;
        height: 32px;
        span:nth-child(1){
          float: left;
          width: 88px;
          height: 32px;
          color: #333;
          font-size: 20px;
          text-align: center;
          line-height: 22px;
          font-family: 'SourceHanSansSC-Regular';
          border-bottom:2px solid #C01B22;
          cursor: pointer;
        }
        span:nth-child(2){
          float: right;
          width: 1108px;
          height: 32px;
          color:#C01B22;
          line-height: 33px;
          font-size: 16px;
          text-align: right;
          border-bottom: 2px solid #EEEEEE;
          cursor: pointer;
          i{
            color: #C01B22;
            font-size: 20px;
            font-weight: bold;
            position: relative;
            top: 2px;
          }
        }
      }
      /deep/.swiper-container{
        width: 100%;
        height: 293px;
        margin-top:19px;
        /deep/.swiper-wrapper{
          width: 100%;
          /deep/.swiper-slide{
            // width: 180px!important;
            height: 100%;
            margin-right: 20px;
            position: relative;
            cursor:pointer;
            .swiper_slide_cover{
              width: 100%;
              height: 231px;
              position: absolute;
              top: 0;
              background: rgba(0, 0, 0, 0.5);
              text-align: center;
              color:#fff;
              padding-top: 125px;
              display: none;
              padding-left:10px;
              padding-right: 10px;
              padding-top:200px;
              overflow: hidden;
              text-overflow: ellipsis;      //超出部分以省略号显示
              white-space: nowrap;
              font-size: 14px;
            }
            a{
              width: 180px;
              height: 231px;
              position: absolute;
              top: 0;
              z-index: 999;
            }
            img{
              width: 180px;
              height: 231px;
            }
            p{
              font-size: 18px;
              color:#000;
              text-align: center;
              font-weight: bold;
            }
          }
          .swiper-slide:hover{
            .swiper_slide_cover{
              display: block;
            }
          }
        }
        /deep/.swiper-button-next{
          width: 70px;
          height: 231px;
          opacity: 1!important;
          position: absolute;
          top: 22px;
          right: 0;
          background:linear-gradient(90deg,rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
          display: none;
          i{
            font-size: 45px;
            color: #fff;
            position: relative;
            top: 80px;
            left: 9px;
          }
        }
        /deep/.swiper-button-prev{
          width: 70px;
          height: 231px;
          opacity: 1!important;
          position: absolute;
          top: 22px;
          left: 0;
          background:linear-gradient(90deg,rgba(0,0,0,1) 0%,rgba(0,0,0,0) 100%);
          display: none;
          i{
            font-size: 45px;
            color: #fff;
            position: relative;
            top: 80px;
            left: 9px;
          }
        }
      }
      .swiper-container:hover{
        .swiper-button-prev,.swiper-button-next{
          display: block;
        }
      }
    }
    .home_contentF{
      width: 1200px;
      height: auto;
      margin: 0 auto;
      margin-top: 41px;
      .flRseniority_just{
        width: 100%;
        height: 32px;
        span:nth-child(1){
          float: left;
          width: 94px;
          height: 32px;
          color: #333;
          font-size: 20px;
          text-align: center;
          line-height: 22px;
          font-family: 'SourceHanSansSC-Regular';
          border-bottom:2px solid #C01B22;
          cursor: pointer;
        }
        span:nth-child(2){
          float: right;
          width: 1103px;
          height: 32px;
          color:#C01B22;
          line-height: 33px;
          font-size: 16px;
          text-align: right;
          border-bottom: 2px solid #EEEEEE;
          cursor: pointer;
          i{
            color: #C01B22;
            font-size: 20px;
            font-weight: bold;
            position: relative;
            top: 2px;
          }
        }
      }
      .home_contentF_bto{
        width: 100%;
        height: 65px;
        margin-top: 18px;
        ul{
          width: 100%;
          height: auto;
          li{
            width: 140px;
            height: 63px;
            float: left;
            list-style: none;
            border: 1px solid #e5dedf;
            margin-right: 33px;
            cursor: pointer;
            img{
              width: 100%;
              height: 100%;
            }
          }
          li:last-child{
            margin-right: 0;
          }
        }
      }
    }
    .home_contentG{
      width:1200px;
      height:auto;
      margin:0 auto;
      margin-top:41px;
      .flRseniority_just{
        width: 100%;
        height: 32px;
        span:nth-child(1){
          float: left;
          width: 88px;
          height: 32px;
          color: #333;
          font-size: 20px;
          text-align: center;
          line-height: 22px;
          font-family: 'SourceHanSansSC-Regular';
          border-bottom:2px solid #C01B22;
          cursor: pointer;
        }
        span:nth-child(2){
          float: right;
          width: 1108px;
          height: 32px;
          color:#C01B22;
          line-height: 33px;
          font-size: 16px;
          text-align: right;
          border-bottom: 2px solid #EEEEEE;
          cursor: pointer;
          i{
            color: #C01B22;
            font-size: 20px;
            font-weight: bold;
            position: relative;
            top: 2px;
          }
        }
      }
      .home_contentC_left_just_ul{
        width:100%;
        height:auto;
        margin-top:15px;
        li:nth-child(1),li:nth-child(3){
          margin-right: 20px;
        }
        li{
          list-style:none;
          width:579px;
          height:118px;
          float:left;
          margin-bottom:24px;
          .periodiCon_cluster_Cont_img{
            width: 198px;
            height: 118px;
            float: left;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .periodiCon_cluster_Cont_right:hover{
            .periodiCon_cluster_Cont_right_p2{
              color:#C01B22;
            }
            p:nth-child(1){
              a{
                color:#C01B22;
              }
            }
            p:nth-child(3){
              span:nth-child(1){
                color:#C01B22;
              }
            }
          }
          .periodiCon_cluster_Cont_right{
            width:370px;
            float: right;
            p:nth-child(1){
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              color: #000000;
              font-size: 16px;
              font-weight: bold;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              a{
                color:#000;
              }
            }
            .periodiCon_cluster_Cont_right_p2{
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              line-clamp: 3;
              -webkit-box-orient: vertical;
              color: #606060;
              font-size:14px;
              margin-top:7px;
              text-align:justify;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              box-orient: vertical;
              // text-indent: 2em;
            }
            p:nth-child(3){
              width: 100%;
              height: 15px;
              margin-top: 9px;
              span:nth-child(1){
                color:#909090;
                font-size: 14px;
                float: left;
              }
            }
          }
        }
        li:nth-child(3),li:nth-child(4){
          margin-bottom: 0;
        }
      }
    }
  }
  #academicB{
    li{
      div{
        width:100%!important;
        clear: both;
        p:nth-child(1){
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .marquee-outer-wrapper{
    overflow: hidden;
    width: 1200px;
    margin: 0 auto;
  }
  .marquee-inner-wrapper{
      height: 40px;
      font-size: 14px;
      color: #C01B22;
      line-height: 40px;
      margin: 0 auto;
      white-space: nowrap;
      position: relative;
  }
　　/* 需要将两个文字内容一样的span放在最右边 */
  .marquee-inner-wrapper span{
      position: absolute;
      top: 0;
      left: 100%;
      height: 100%;
  }
　　/* 定义第一个span的animation：时长 动画名字 匀速 循环 正常播放 */
  .first-marquee{
      -webkit-animation: 50s first-marquee linear infinite normal;
      animation: 50s first-marquee linear infinite normal;
      padding-right: 100%;
  }
  @keyframes first-marquee {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    100% {
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
      display: none;
    }
  }
  .second-marquee{
    -webkit-animation: 25s first-marquee linear 12s infinite normal;
    animation: 25s first-marquee linear 12s infinite normal;
    padding-right: 53%;
  }
  @keyframes second-marquee {
    0% {
      -webkit-transform: translate3d(0%, 0, 0);
      transform: translate3d(0%, 0, 0);
    }
    100% {
      -webkit-transform: translate3d(-200%, 0, 0);
      transform: translate3d(-200%, 0, 0);
      display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/home/index.vue